import { render, staticRenderFns } from "./FormModule.vue?vue&type=template&id=271f2365&scoped=true"
import script from "./FormModule.vue?vue&type=script&lang=ts"
export * from "./FormModule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271f2365",
  null
  
)

export default component.exports